/**
 * Tipos de feriado.
 *
 * Fuente única: la usan el ABM de feriados (el select del alta y la modificación) y el
 * filtro por tipo de la vista de series. Por eso vive acá y no en la carpeta de una de
 * las dos páginas.
 *
 * OJO con los CÓDIGOS: "N" y "P" son una suposición nuestra, no un contrato confirmado.
 * Las etiquetas sí están confirmadas (Nacional y Provincial, y son las dos únicas). Se
 * eligió la inicial sola porque es lo que usa el resto del módulo para los catálogos
 * chicos —ver ESTADOS_AGENTE, que maneja "A", "S", "B", "L"—, pero si el back espera
 * otra cosa ("NAC"/"PROV", 1/2, la palabra entera) se cambia ACÁ y en ningún otro lado:
 * las vistas leen de esta lista.
 */
export const TIPOS_FERIADO = [
    { cod: "N", label: "Nacional" },
    { cod: "P", label: "Provincial" },
];

/**
 * Código -> etiqueta legible, para las columnas de las grillas.
 *
 * Si el código no está en la tabla devuelve el crudo en vez de vacío: un valor
 * inesperado del back tiene que verse, no desaparecer. Mismo criterio que `labelDeLey`.
 */
export const labelDeTipoFeriado = (cod) =>
    TIPOS_FERIADO.find((t) => t.cod === cod)?.label ?? (cod ?? "");
